import "./Frog.scss";

// Each part is a lathe: a fan of flat ellipses revolved around the part's own
// axis, which is what gives the frog volume in 3D.
//
// The slice counts below are the whole performance story - these planes are
// repainted every frame, and the frame rate tracks their number almost
// linearly. Keep each one equal to the plane count of the matching
// ellipsoid() call in Frog.scss (its lathe planes plus its caps).
function Part({ className, slices, children }) {
  return (
    <div className={className}>
      {Array.from({ length: slices }, (_, i) => (
        <i key={i} />
      ))}
      {children}
    </div>
  );
}

// Hip -> knee -> ankle, each joint its own pivot so it can rotate in the
// frame its parent segment left it in.
function HindLeg({ side }) {
  return (
    <div className={`frog__hip frog__hip--${side}`}>
      <div className="frog__hip-rot">
        <Part className="frog__thigh" slices={5} />
        <div className="frog__knee">
          <div className="frog__knee-rot">
            <Part className="frog__shin" slices={5} />
            <div className="frog__ankle">
              <div className="frog__ankle-rot">
                <Part className="frog__foot" slices={4} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

function FrontLeg({ side }) {
  return (
    <div className={`frog__shoulder frog__shoulder--${side}`}>
      <div className="frog__shoulder-rot">
        <Part className="frog__arm" slices={4} />
        <div className="frog__elbow">
          <div className="frog__elbow-rot">
            <Part className="frog__forearm" slices={4} />
            <div className="frog__wrist">
              <div className="frog__wrist-rot">
                <Part className="frog__hand" slices={3} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

function Frog({ onClick }) {
  return (
    <div className="frog-scene" onClick={onClick}>
      <div className="frog-journey">
        <div className="frog-shadow"></div>
        <div className="frog-hop">
          <div className="frog-stage">
            <div className="frog-yaw">
              <div className="frog-pitch">
                <Part className="frog__body" slices={10} />
                <Part className="frog__head" slices={8} />
                <div className="frog__throat">
                  <Part className="frog__throat-sac" slices={5} />
                </div>
                <Part className="frog__eye frog__eye--l" slices={5} />
                <Part className="frog__eye frog__eye--r" slices={5} />
                <Part className="frog__pupil frog__pupil--l" slices={4} />
                <Part className="frog__pupil frog__pupil--r" slices={4} />
                <HindLeg side="l" />
                <HindLeg side="r" />
                <FrontLeg side="l" />
                <FrontLeg side="r" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default Frog;
